<template>
  <v-app-bar app elevate-on-scroll dark color="primary">
    <div class="ml-8">
      <v-row>
        <v-col cols="1">
          <v-tooltip
            :text="inHome ? enums.titles.PRODUCT : enums.messages.GO_TO_HOME"
            location="start"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                icon
                class="v-btn v-btn--text theme--dark v-size--default"
                @click="clickHome"
                v-bind="props"
              >
                <v-icon class="logo">
                  <img
                    src="/favicon.ico"
                    :alt="enums.titles.PRODUCT"
                    class="custom-icon"
                  />
                </v-icon>
              </v-btn>
            </template>
          </v-tooltip>
        </v-col>
        <v-col
          cols="11"
          class="d-flex align-center"
          style="justify-content: end"
        >
          <v-menu transition="slide-y-transition">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                class="v-btn v-btn--text theme--dark v-size--default pr-1"
              >
                {{ userName }}
                <v-icon size="22px" class="ma-2">{{ userIcon }}</v-icon>
              </v-btn>
            </template>
            <v-list class="user-menu-list">
              <v-list-item
                v-for="(item, i) in userMenu"
                :key="i"
                :id="'v-btn-' + item.action"
                class="menu-item-container"
                @click="handleItemClick(item.action)"
              >
                <template v-slot:prepend>
                  <v-icon 
                    :icon="item.icon" 
                    size="20"
                    class="menu-icon"
                    :class="item.class"
                  ></v-icon>
                </template>
                <v-list-item-title 
                  class="menu-text"
                  :class="item.class"
                >
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </div>
  </v-app-bar>
  <change-password-popup
    v-if="showChangePassword"
    @close="closeModalChangePassword"
  />
  <datos-personales-popup
    v-if="showDatosPersonales"
    :user-filters="userFilters"
    @close="closeModalDatosPersonales"
  />
</template>

<script>
import ChangePasswordPopup from "../layout/ChangePassword.vue";
import DatosPersonalesPopup from "../layout/DatosPersonales.vue";
import { mapActions, mapGetters } from "vuex";
import enums from "@/utils/enums/index";

export default {
  components: {
    ChangePasswordPopup,
    DatosPersonalesPopup,
  },
  props: {
    inHome: {
      type: Boolean,
    },
  },
  data() {
    return {
      homeIcon: enums.icons.HOME_ICON,
      userIcon: enums.icons.USER_ICON,
      showChangePassword: false,
      showDatosPersonales: false,
      enums: enums,
      // Variables para tipo de usuario
      esAdmin: false,
      isUserFinanciador: false,
      // Datos del usuario para pasar como props
      userFilters: null,
    };
  },
  computed: {
    ...mapGetters("logIn", ["userName"]),
    userMenu() {
      const menu = [];
      
      // Solo mostrar "Datos personales" si NO es admin ni financiador
      if (!this.esAdmin && !this.isUserFinanciador) {
        menu.push({
          text: "DATOS PERSONALES",
          icon: enums.icons.DETAILS_USER,
          action: "personalData"
        });
      }
      
      // Siempre mostrar cambiar contraseña
      menu.push({
        text: "CAMBIAR CONTRASEÑA",
        icon: enums.icons.LOCK_RESET,
        action: "changePassword"
      });
      
      // Siempre mostrar cerrar sesión
      menu.push({
        text: "CERRAR SESIÓN",
        icon: enums.icons.LOGOUT_ICON,
        action: "logout",
        class: "text-red"
      });
      
      return menu;
    }
  },
  created() {
    const storedUserName = sessionStorage.getItem("userName");
    if (storedUserName) {
      this.$store.commit("logIn/setUserName", storedUserName);
    }
    const changePassword = sessionStorage.getItem("changePassword") === "true";
    if (changePassword) {
      this.setAlert({
        type: "warning",
        message: "Es necesario cambiar la contraseña para continuar.",
      });
      this.showChangePassword = true;
    }
    
    // Cargar tipo de usuario para determinar qué opciones mostrar
    this.loadUserType();
  },
  methods: {
    ...mapActions({
      setAlert: "user/setAlert",
      getFiltersByUser: "solicitud/getFiltersByUser",
    }),
    handleItemClick(action) {
      switch (action) {
        case "personalData":
          this.goToPersonalData();
          break;
        case "changePassword":
          this.openModalChangePassword();
          break;
        case "logout":
          this.logOut();
          break;
      }
    },
    goToPersonalData() {
      this.showDatosPersonales = true;
    },
    openModalChangePassword() {
      this.showChangePassword = true;
    },
    closeModalChangePassword() {
      this.showChangePassword = false;
    },
    closeModalDatosPersonales() {
      this.showDatosPersonales = false;
    },
    logOut() {
      sessionStorage.setItem("token", "");
      sessionStorage.removeItem("userName");
      this.$router.push("/login");
      this.$store.commit("menu/setPermisos", []);
    },
    clickHome() {
      if (this.inHome) location.reload();
      else this.$router.push("/");
    },
    async loadUserType() {
      try {
        const filters = await this.getFiltersByUser();
        
        // Almacenar los datos para pasarlos como props
        this.userFilters = filters;
        
        // Determinar tipo de usuario
        if (filters && filters.esAdmin) {
          this.esAdmin = true;
        } else if (filters && filters.financiadorId !== null) {
          this.isUserFinanciador = true;
        }
        // Los demás tipos (emisor, prestador, farmacia) pueden ver datos personales
      } catch (error) {
        console.error("Error al cargar tipo de usuario:", error);
      }
    },
  },
};
</script>

<style scoped>
.custom-icon {
  width: 40px;
  height: 40px;
  filter: contrast(100%) grayscale(100%);
}
.ml-8,
.v-row {
  width: 100%;
}

/* Estilos para el menú desplegable del usuario */
.user-menu-list {
  min-width: 180px;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  padding: 4px 0;
}

.menu-item-container {
  padding: 8px 12px;
  margin: 1px 6px;
  border-radius: 4px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.menu-item-container:hover {
  background-color: rgba(103, 58, 183, 0.08);
  transform: translateX(2px);
}

.menu-icon {
  margin-right: 8px;
  color: rgba(0, 0, 0, 0.6);
}

.menu-text {
  font-weight: 500;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.87);
  letter-spacing: 0.2px;
}

/* Estilo especial para cerrar sesión */
.text-red .menu-icon,
.text-red .menu-text {
  color: #d32f2f !important;
}

.menu-item-container:hover .text-red .menu-icon,
.menu-item-container:hover .text-red .menu-text {
  color: #b71c1c !important;
}

/* Separador visual antes de cerrar sesión */
.menu-item-container:last-child {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  margin-top: 6px;
  padding-top: 10px;
}
</style>
